import router from '../router'
import store from "../store";
import sensorsdata from 'sa-sdk-javascript'
import {
  getDevice,
  getQueryString
} from "@/config/utils";
import api from "@/api/index";
import {
  createSignature,
  goToWechatPage
} from "@/utils/index";
import {
  isTgjApp,
  loadingPageFinish
} from "@/utils/nativeApi.js";
import appObj from '@/utils/tgjApp';
import {
  mall
} from '@/config/env';
import { svMigrationMatch } from "./svMigration"

let device = getDevice()
import Vue from "vue";
let _this = new Vue();
let getWechatSignUrl = (to)=>{
	const u = navigator.userAgent;
	let isIos = u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
	if(isIos || true) {
		return (window.location.origin + to.fullPath)
	} else {
		return window.location.href;
	}
};

export default {
  install() {
    const history = window.sessionStorage;
    let historyCount = history.getItem('count') * 1;
    router.beforeEach(function (to, from, next) {

    	store.commit("setWechatSignUrl", getWechatSignUrl(to));

		  /* 路由发生变化修改页面title */
      if (to.meta.title) {
        document.title = to.meta.title
      }

      // 收费服务迁移后-老页面失效 路由匹配检查
      if(svMigrationMatch(to,next)){
        return
      }

      const toIndex = history.getItem(to.path);
      const fromIndex = history.getItem(from.path);
      if (toIndex) {
        if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
          store.commit('updateDirection', {
            direction: 'forward'
          })
        } else {
          store.commit('updateDirection', {
            direction: 'reverse'
          })
        }
      } else {
        ++historyCount;
        history.setItem('count', historyCount);
        to.path !== '/' && history.setItem(to.path, historyCount);
        store.commit('updateDirection', {
          direction: 'forward'
        })
      }
      if (/\/http/.test(to.path)) {
        let url = to.path.split('http')[1];
        window.location.href = `http${url}`
      } else {
        //	next()
      }
      store.commit('updateLoadingStatus', {
        isLoading: true
      })
      let nextPage = getQueryString("nextPage") || sessionStorage.getItem("nextPage");;
      let code = getQueryString("access_code") || getQueryString("code");
      let token = getQueryString("token") || getQueryString("tbwxmpToken");
      let returnURL = getQueryString("returnURL");
      let transferURL = getQueryString("transferURL");
      let storage_token = sessionStorage.getItem("app_token");
      let actUnionId = getQueryString("actUnionId");
      if (isTgjApp()) {
        loadingPageFinish('1')
      }
      if (nextPage) {
        sessionStorage.setItem("nextPage", 1);
        next()
      }else if(actUnionId){
        api.getTokenByUnionId({
          key:actUnionId
        }).then(function (result) {
          if(result.data){
            let accessToken = result.data.split("accessToken:");
            sessionStorage.setItem("app_token", accessToken[1]);
            next()
          }
        })
      } else if (isTgjApp()) {
        //app打开，且没有token
        if (!storage_token) {
          appObj.getUserMarkNoLogin(['2'], (appToken) => {
            console.log(appToken)
            if (appToken) {
              sessionStorage.setItem("errorNum", 1);
              sessionStorage.setItem('app_token', appToken);
              nextContent();
            } else {
              gotoLogin(true)
            }
          });
        } else {
          nextContent();
        }
      } else if (token && !storage_token) {
        sessionStorage.setItem("errorNum", 1);
        sessionStorage.setItem("app_token", token);
        nextContent()
      } else if (storage_token) {
        nextContent()
      } else if (!storage_token && code) {
        //没有token且地址栏有code
        if (transferURL) {
          pageTransferURL(transferURL, code)
        } else {
          getUserToken(code)
        }
      } else {
        if (store.state.isWx) {
          if (!to.meta.requireAuth && !to.meta.iswx) {
            next()
          } else if (to.meta.iswx) {
            getWechatToken(true);
          } else if (!storage_token) {
            let targetUrl = window.location.href;
            location.replace(goToWechatPage(targetUrl))
          } else {
            if (transferURL) {
              pageTransferURL(transferURL, "")
            } else {
              nextContent()
            }
          }
        } else {
          if (to.meta.requireAuth) {
            if (isTgjApp()) {
              gotoLogin(true)
            } else {
              let targetUrl = window.location.href;
              location.replace(goToWechatPage(targetUrl))
            }
          } else {
            //没有token的
            //getUserInfo()
            next()
          }
        }
      }

      function gotoLogin(source) {
        let url = mall + "/ccs/smsLogin?tenantId=T0001&outLink=yes&redirectUrl=" +
          encodeURIComponent(window.location.href);
        if (source) {
          location.replace(url);
        } else {
          location.href = url
        }
      }

      async function nextContent() {
        if (to.meta.noNext) {
          //await getUserInfo()
        } else {
          await getUserInfo()
          await getWechatToken();
        }
        next()
      }
      async function getUserToken(code) {
        let result = await api.getUserToken({
          code: code
        });
        if (result.status == 1) {
          if (result.data) {
            sessionStorage.setItem("errorNum", 1);
            let resultData = result.data;
            sessionStorage.setItem("app_token", resultData.accessToken);
            //获取微信的token
            if (returnURL && to.path == "/redirectUri") {
              //重定向
              getUserInfo(resultData.accessToken)
            } else {
              if (to.meta.noNext) {
                // await getUserInfo()
              } else {
                await getUserInfo()
                await getWechatToken();
              }
              next()
            }
          } else {
            handleErrorTips()
          }
        } else {
          handleErrorTips()
        }
      }
      async function getUserInfo(token) {
        if (to.meta.userinfo) {
          let result = await api.getCustDetails();
          if (result.status == 1) {
            if (result.data) {
              let userInfo = result.data
              store.state.userInfo = userInfo;
              setUserBindStatus(userInfo.phoneNumber)
              sensorsdata.login(userInfo.unionId)
              sensorsdata.setProfile({
                wx_open_id: userInfo.openId,
                nick_name: userInfo.nickName
              });
            }
          }
        }
        if (token) {
          pageReturnURL(returnURL, token)
        } else if (returnURL && to.path == "/redirectUri") {
          pageReturnURL(returnURL, "")
        } else {
          let isBind = sessionStorage.getItem("isBind")
          if (isBind == '1') {
            sessionStorage.setItem("isBind", "1")
            store.commit("saveBindStatus", true);
          } else if (isBind == '0') {
            sessionStorage.setItem("isBind", "0")
            store.commit("saveBindStatus", false);
          } else {
            let result = await api.getWxInfo()
            if (result.status == 1) {
              if (result.data) {
                let userInfo = result.data
                let bind = userInfo.cuserId;
                store.state.openId = userInfo.openId
                store.state.userInfo = userInfo;
                sensorsdata.login(userInfo.unionId)
                sensorsdata.setProfile({
                  wx_open_id: userInfo.openId,
                  nick_name: userInfo.nickName
                });
                setUserBindStatus(bind)
              }
            }
          }
        }
      }

      function setUserBindStatus(bind) {
        if (bind) {
          sessionStorage.setItem("isBind", "1")
          store.commit("saveBindStatus", true);
        } else {
          sessionStorage.setItem("isBind", "0")
          store.commit("saveBindStatus", false);
        }
      }

      async function getWechatToken(status) {
        if (isTgjApp()) {
          return false;
        }
        let url = location.href
        let result = await api.getWechatToken({
          url: url
        });
        if (result.status == 1) {
          if (result.data) {
            let wechatToken = result.data;
            sessionStorage.setItem("wechatToken", JSON.stringify(wechatToken));
          } else {
            sessionStorage.setItem("wechatToken", "");
          }
        }
        if (status) {
          next()
        }
      }

      async function pageTransferURL(transferURL, code) {
        let newCode
        if (code == "") {
          let res = await api.getCodeByToken();
          if (res.status == 1) {
            if (res.data) {
              newCode = res.data.code;
            }
          }
        } else {
          newCode = code
        }
        transferURL = decodeURIComponent(transferURL);
        if (transferURL.indexOf('?') > 0) {
          transferURL += '&code=' + newCode
        } else {
          transferURL += '?code=' + newCode
        }
        location.replace(transferURL);
      }

      function pageReturnURL(returnURL, token) {
        let newToken
        if (token == "") {
          newToken = storage_token
        } else {
          newToken = token
        }
        returnURL = decodeURIComponent(returnURL);
        if (returnURL.indexOf('?') > 0) {
          returnURL += '&tbwxmpToken=' + newToken + '&unionid=' + store.state.userInfo.unionId;
        } else {
          returnURL += '?tbwxmpToken=' + newToken + '&unionid=' + store.state.userInfo.unionId;
        }
        location.replace(returnURL);
      }

      let handleErrorTips = () => {
        let errorNum = sessionStorage.getItem('errorNum')
        if (!errorNum) {
          errorNum = 1
          sessionStorage.setItem("errorNum", errorNum);
        } else {
          errorNum++
          sessionStorage.setItem("errorNum", errorNum);
        }
        if (errorNum < 4) {
          sessionStorage.setItem("app_token", "");
          sessionStorage.setItem("wechatToken", "");
          let targetUrl = window.location.href;
          location.replace(goToWechatPage(targetUrl));
        } else {
          store.commit("setErrorTips", true);
        }
      }
    });

    router.afterEach(function (to, from) {
      store.commit('updateLoadingStatus', {
        isLoading: false
      });
      if (device == 'ios' || device == 'iPhoneX') {
        if (!isTgjApp()) {
            let wxSignUrl = sessionStorage.getItem("wxSignUrl");
            if (!wxSignUrl) {
              sessionStorage.setItem("wxSignUrl", document.URL);
              createSignature()
            }
        }
      }
    })

    router.onError(function (err) {
      console.log(err)
      if (err && err != '{}') {
        _this.$alert({
          content: '因系统维护导致资源文件异常,请返回再重新进入。',
          onHide() {
            if (isTgjApp()) {
              appObj.loadingPageFinish(['2'])
              appObj.backAction()
            } else {
              var date = new Date();
              var time = date.getTime()
              location.replace("/?t=" + time)
            }

          }
        });
      }
    })

  }
}



// WEBPACK FOOTER //
// ./src/utils/routerIntercept.js